import { assetUrl } from '../../config';

export const CollectionCollage = [
    {
        title:'Infected',
        description:'',
        author:'Beeple',
        poster:assetUrl('collection/collage/thumbs/Infected.jpg'),
        popupSrc:assetUrl('collection/collage/Infected.mp4'),
        href:'https://opensea.io/assets/0xd92e44ac213b9ebda0178e1523cc0ce177b7fa96/100020009',
        // `video`, not `img`: popupSrc is an .mp4. With type:'img' the lightbox
        // rendered <img src="...Infected.mp4"> and showed nothing on click.
        type:'video',
    },
    {
        title:'Into the Ether',
        description:'',
        author:'Beeple',
        poster:assetUrl('collection/collage/thumbs/IntoTheEther.jpg'),
        popupSrc:assetUrl('collection/collage/IntoTheEther.mp4'),
        href:'https://opensea.io/assets/0xd92e44ac213b9ebda0178e1523cc0ce177b7fa96/100030151',
        type:'video',
    },
    {
        title:'Biological Collectible',
        description:'',
        author:'Beeple',
        poster:assetUrl('collection/collage/thumbs/BiologicalCollectible.jpg'),
        popupSrc:assetUrl('collection/collage/BiologicalCollectible.mp4'),
        href:'https://opensea.io/assets/0xdd012153e008346591153fff28b0dd6724f0c256/100010087',
        type:'video',
    },
    {
        title:'Bear-23',
        description:'',
        author:'XCOPY',
        poster:assetUrl('collection/collage/thumbs/XCOPYBear23.jpg'),
        popupSrc:assetUrl('collection/collage/XCOPYBear23.jpg'),
        href:'https://opensea.io/assets/0x909899c5dbb5002610dd8543b6f638be56e3b17e/57896044618658097711785492504343953929357251268187789727435788863410710528454',
        type:'img',
    },
    {
        title:'Bear-24',
        description:'',
        author:'XCOPY',
        poster:assetUrl('collection/collage/thumbs/XCOPYBear24.png'),
        popupSrc:assetUrl('collection/collage/XCOPYBear24.png'),
        href:'https://opensea.io/assets/0x909899c5dbb5002610dd8543b6f638be56e3b17e/57896044618658097711785492504343953929357251268187789727435788863410710527073',
        type:'img',
    },
    {
        title:'Giving My Heart Away',
        description:'',
        author:'Fewocious',
        poster:assetUrl('collection/collage/thumbs/GivingMyHeartAway.jpg'),
        popupSrc:assetUrl('collection/collage/GivingMyHeartAway.mp4'),
        href:'https://opensea.io/assets/0xe4605d46fd0b3f8329d936a8b258d69276cba264/122',
        type:'video',
    },
    {
        title:'BLOOMED',
        description:'',
        author:'Fvckrender',
        poster:assetUrl('collection/collage/thumbs/Bloomed.jpg'),
        popupSrc:assetUrl('collection/collage/Bloomed.mp4'),
        href:'https://opensea.io/assets/0x1766ed38c58324744ea74c6161b8259e9aa995a9/13300020003',
        type:'video',
    },
    {
        title:'Zelda Vending Machine',
        description:'',
        author:'SeerLight',
        poster:assetUrl('collection/collage/thumbs/ZeldaVendingMachine.png'),
        popupSrc:assetUrl('collection/collage/ZeldaVendingMachine.mp4'),
        href:'https://opensea.io/assets/0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0/27124',
        type:'video',
    },
    {
        title:'GODBUG',
        description:'',
        author:'PROBZZZ',
        poster:assetUrl('collection/collage/thumbs/GodBug.jpg'),
        popupSrc:assetUrl('collection/collage/GodBug.mp4'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/69353',
        type:'video',
    },
    {
        title:'Designer & Client',
        description:'',
        author:'Deekaymotion',
        poster:assetUrl('collection/collage/thumbs/DesignerClient.jpg'),
        popupSrc:assetUrl('collection/collage/DesignerClient.mp4'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/59391',
        type:'video',
    },
    {
        title:'Character Type',
        description:'',
        author:'Deekaymotion',
        poster:assetUrl('collection/collage/thumbs/CharacterType.jpg'),
        popupSrc:assetUrl('collection/collage/CharacterType.mp4'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/2201',
        type:'video',
    },
    {
        title:'Long Way Down',
        description:'',
        author:'Phil Tippett',
        poster:assetUrl('collection/collage/thumbs/LongWayDown.jpg'),
        popupSrc:assetUrl('collection/collage/LongWayDown.mp4'),
        href:'https://opensea.io/assets/0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0/27265',
        type:'video',
    },
    {
        title:'Cybercluck 2077',
        description:'',
        author:'BakaArts',
        poster:assetUrl('collection/collage/thumbs/Cybercluck2077.jpg'),
        popupSrc:assetUrl('collection/collage/Cybercluck2077.jpg'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/471',
        type:'img',
    },
    {
        title:'Every Carnaval Has An End',
        description:'',
        author:'Vini Naso',
        poster:assetUrl('collection/collage/thumbs/EveryCarnavalHasAnEnd.jpg'),
        popupSrc:assetUrl('collection/collage/EveryCarnavalHasAnEnd.mp4'),
        href:'https://opensea.io/assets/0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0/25216',
        type:'video',
    },
            // Media missing: TheVoid.jpg / massonayvid34.mp4 never existed in this
        // repo or its git history — they only ever lived on the dead staging4.ca.
        // Uncomment once the files are re-sourced from the artist or OpenSea.
        // {
//         title:'the V01D / 017-001',
//         description:'',
//         author:'Praystation',
//         poster:assetUrl('collection/collage/thumbs/TheVoid.jpg'),
//         popupSrc:assetUrl('collection/collage/massonayvid34.mp4'),
//         href:'https://opensea.io/assets/0x9e8d7fbb7d49ccf03b9bcacc4b3bbd7384e2cfff/32',
//         type:'video',
//     },
    {
        title:'Tile [35, 12] - One Step at a Time',
        description:'',
        author:'Pak',
        poster:assetUrl('collection/collage/thumbs/OneStepAtATime.jpeg'),
        popupSrc:assetUrl('collection/collage/OneStepAtATime.jpeg'),
        href:'https://opensea.io/assets/0x7ccdc136619cddf744122a938b4448eda1590fe1/139?__cf_chl_jschl_tk__=pmd_rZmJrP9y1Ys3GJp3bRu7fTaEJ6zadVgYTSJJDlGtpPA-1634712381-0-gqNtZGzNAjujcnBszQhl',
        type:'img',
    },
    {
        title:'Life\'s a Mess',
        description:'',
        author:'Chewy Stoll',
        poster:assetUrl('collection/collage/thumbs/LifesAMess.jpeg'),
        popupSrc:assetUrl('collection/collage/LifesAMess.jpeg'),
        href:'https://opensea.io/assets/0x2a46f2ffd99e19a89476e2f62270e0a35bbf0756/38842',
        type:'img',
    },
    {
        title:'Nostalgia',
        description:'',
        author:'Musketon',
        poster:assetUrl('collection/collage/thumbs/Nostalgia.jpg'),
        popupSrc:assetUrl('collection/collage/Nostalgia.jpg'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/1639',
        type:'img',
    },
    {
        title:'White Ford Bronco',
        description:'',
        author:'Brendan Dawes',
        poster:assetUrl('collection/collage/thumbs/WhiteFordBronco.jpg'),
        popupSrc:assetUrl('collection/collage/WhiteFordBronco.jpg'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/68027',
        type:'img',
    },
    {
        title:'Retrofitted Machines',
        description:'',
        author:'TOKYOLUV',
        poster:assetUrl('collection/collage/thumbs/RetrofittedMachines.jpg'),
        popupSrc:assetUrl('collection/collage/RetrofittedMachines.mp4'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/37999',
        type:'video',
    },
    {
        title:'Neon Chaos',
        description:'',
        author:'Anocam',
        poster:assetUrl('collection/collage/thumbs/NeonChaos.jpg'),
        popupSrc:assetUrl('collection/collage/NeonChaos.jpg'),
        href:'https://opensea.io/assets/0xfbeef911dc5821886e1dda71586d90ed28174b7d/364851',
        type:'img',
    },
    {
        title:'Running In Place',
        description:'',
        author:'Sinclair',
        poster:assetUrl('collection/collage/thumbs/RunningInPlace.jpeg'),
        popupSrc:assetUrl('collection/collage/RunningInPlace.jpeg'),
        href:'https://opensea.io/assets/0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0/16559',
        type:'img',
    },
    {
        title:'Symphony',
        description:'',
        author:'Roger Kilimanjaro',
        poster:assetUrl('collection/collage/thumbs/Symphony.jpg'),
        popupSrc:assetUrl('collection/collage/Symphony.mp4'),
        href:'https://opensea.io/assets/0x95c43f41965b6d2ab803a9850dcc4ce3b9a064f7/23100010001',
        type:'video',
    },
    {
        title:'The Magical Item #17: Cheche: The Night Arcade',
        description:'',
        author:'Migrating Lines',
        poster:assetUrl('collection/collage/thumbs/TheNightArcade.jpg'),
        popupSrc:assetUrl('collection/collage/TheNightArcade.mp4'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/88218',
        type:'video',
    },
    {
        title:'Miles High',
        description:'',
        author:'BossLogic',
        poster:assetUrl('collection/collage/thumbs/MilesHigh.jpg'),
        popupSrc:assetUrl('collection/collage/MilesHigh.mp4'),
        href:'https://opensea.io/assets/0x8ae06a29a816580cbd069e460dd57c6c964bb3da/7500020008',
        type:'video',
    },
    {
        title:'Forever Mamba',
        description:'',
        author:'BossLogic',
        poster:assetUrl('collection/collage/thumbs/ForeverMamba.jpg'),
        popupSrc:assetUrl('collection/collage/ForeverMamba.mp4'),
        href:'https://opensea.io/assets/0x8ae06a29a816580cbd069e460dd57c6c964bb3da/7500010178',
        type:'video',
    },
    {
        title:'Nebular 5',
        description:'',
        author:'Jsf',
        poster:assetUrl('collection/collage/thumbs/nebular-still.gif'),
        popupSrc:assetUrl('collection/collage/nebular.gif'),
        href:'https://opensea.io/assets/0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0/22825',
        type:'img',
    },
    {
        title:'Gentle Push',
        description:'',
        author:'Colin Benders',
        poster:assetUrl('collection/collage/thumbs/GentlePush-still.gif'),
        popupSrc:assetUrl('collection/collage/GentlePush.gif'),
        href:'https://opensea.io/assets/0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0/26595',
        type:'img',
    },
    {
        title:'Tangerine Dreams',
        description:'',
        author:'mvhvma',
        poster:assetUrl('collection/collage/thumbs/TangerineDreams.jpg'),
        popupSrc:assetUrl('collection/collage/TangerineDreams.jpg'),
        href:'https://opensea.io/assets/0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0/22264',
        type:'img',
    },
    {
        title:'Game Cube VIII - Emulator',
        description:'',
        author:'Jerry Liu',
        poster:assetUrl('collection/collage/thumbs/GameCube8-still.gif'),
        popupSrc:assetUrl('collection/collage/GameCube8.gif'),
        href:'https://opensea.io/assets/0xfbeef911dc5821886e1dda71586d90ed28174b7d/278476',
        type:'img',
    },
    {
        title:'System Override',
        description:'',
        author:'dannh',
        poster:assetUrl('collection/collage/thumbs/SystemOverride.jpg'),
        popupSrc:assetUrl('collection/collage/SystemOverride.mp4'),
        href:'https://opensea.io/assets/0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0/27686',
        type:'video',
    },
    {
        title:'Poly Float Pineapple',
        description:'',
        author:'VansDesign',
        poster:assetUrl('collection/collage/thumbs/PolyFloatPineapple.jpg'),
        popupSrc:assetUrl('collection/collage/PolyFloatPineapple.mp4'),
        href:'https://opensea.io/assets/0xe4605d46fd0b3f8329d936a8b258d69276cba264/44',
        type:'video',
    },
    {
        title:'Ambiance',
        description:'',
        author:'Mark Malta',
        poster:assetUrl('collection/collage/thumbs/Ambiance.jpg'),
        popupSrc:assetUrl('collection/collage/Ambiance.mp4'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/7389',
        type:'video',
    },
    {
        title:'Ghost',
        description:'',
        author:'Marc Tudisco',
        poster:assetUrl('collection/collage/thumbs/Ghost.jpg'),
        popupSrc:assetUrl('collection/collage/Ghost.mp4'),
        href:'https://opensea.io/assets/0x27c3dd629539f72d58360ffad470ad8fe4b72523/15400010001',
        type:'video',
    },
    {
        title:'Kawaii Multitasker',
        description:'',
        author:'Miguelgarest',
        poster:assetUrl('collection/collage/thumbs/KawaiiMultitasker.jpg'),
        popupSrc:assetUrl('collection/collage/KawaiiMultitasker.mp4'),
        href:'https://opensea.io/assets/0xfbeef911dc5821886e1dda71586d90ed28174b7d/243328',
        type:'video',
    },
    {
        title:'I Forget Where We Were',
        description:'',
        author:'Nate Hill',
        poster:assetUrl('collection/collage/thumbs/IForgetWhereWeWere.jpg'),
        popupSrc:assetUrl('collection/collage/IForgetWhereWeWere.mp4'),
        href:'https://opensea.io/assets/0xaad5fc352ddf2b60074bbc9a6fd0867b2cc01547/30600030003',
        type:'video',
    },
    {
        title:'Still Chained To The Roots',
        description:'',
        author:'Gary Cartlidge',
        poster:assetUrl('collection/collage/thumbs/StillChainedToMyRoots.jpg'),
        popupSrc:assetUrl('collection/collage/StillChainedToMyRoots.jpg'),
        href:'https://opensea.io/assets/0x36d16e0758d1b52c28c4579e12b9efa0d23bab29/142',
        type:'img',
    },
    {
        title:'Tokyo Summer Dreams',
        description:'',
        author:'Elora Pautrat',
        poster:assetUrl('collection/collage/thumbs/TokyoSummerDreams.jpg'),
        popupSrc:assetUrl('collection/collage/TokyoSummerDreams.jpg'),
        href:'https://opensea.io/assets/0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0/19286',
        type:'img',
    },
    {
        title:'Sad Snoopy',
        description:'',
        author:'Defaced',
        poster:assetUrl('collection/collage/thumbs/SadSnoopy.jpeg'),
        popupSrc:assetUrl('collection/collage/SadSnoopy.jpeg'),
        href:'https://opensea.io/assets/0x2a46f2ffd99e19a89476e2f62270e0a35bbf0756/39224',
        type:'img',
    },
    {
        title:'World Inside',
        description:'',
        author:'Rolzay',
        poster:assetUrl('collection/collage/thumbs/WorldInside.jpg'),
        popupSrc:assetUrl('collection/collage/WorldInside.mp4'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/2446',
        type:'video',
    },
    {
        title:'Secrets',
        description:'',
        author:'jazsi',
        poster:assetUrl('collection/collage/thumbs/Secrets.jpg'),
        popupSrc:assetUrl('collection/collage/Secrets.jpg'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/663',
        type:'img',
    },
    {
        title:'Visiting Friends #5/5',
        description:'',
        author:'Alexis Christodoulou',
        poster:assetUrl('collection/collage/thumbs/VisitingFriends.jpg'),
        popupSrc:assetUrl('collection/collage/VisitingFriends.mp4'),
        href:'https://opensea.io/assets/0xeeb9247a2d11ed4032125656a4b75daadfefaf79/29700050005',
        type:'video',
    },
    {
        title:'3AM #4/5',
        description:'',
        author:'Alexis Christodoulou',
        poster:assetUrl('collection/collage/thumbs/3AM.jpg'),
        popupSrc:assetUrl('collection/collage/3AM.mp4'),
        href:'https://opensea.io/assets/0xeeb9247a2d11ed4032125656a4b75daadfefaf79/29700060004',
        type:'video',
    },
    {
        title:'To the Moon',
        description:'',
        author:'Lushsux',
        poster:assetUrl('collection/collage/thumbs/ToTheMoon.jpg'),
        popupSrc:assetUrl('collection/collage/ToTheMoon.mp4'),
        href:'https://opensea.io/assets/0x30f23d387c076d61fa5017516bedadee01a27356/8800010010',
        type:'video',
    },
    {
        title:'Why would I care if I\'m just a cat?',
        description:'',
        author:'Mad Dog Jones',
        // The original .png was a 6 KB, fully transparent 480x600 file — it
        // loaded fine but rendered as an empty black tile. Replaced with a
        // frame extracted from the artwork's own mp4 (t=10s), encoded to JPEG
        // to match the other 48 thumbnails.
        poster:assetUrl('collection/collage/thumbs/WhyWouldICare.jpg'),
        popupSrc:assetUrl('collection/collage/WhyWouldICare.mp4'),
        href:'https://opensea.io/assets/0xd949a444f29ede73f517942eb4d8e3ccdab25d58/10400020438?__cf_chl_jschl_tk__=pmd_kD3gtzzgtpk_GpJ8ZEpoHitLBqZS7DN.9LPfsJraxBs-1634714242-0-gqNtZGzNAjujcnBszQh9',
        type:'video',
    },
    {
        title:'George Floyd Portrait',
        description:'',
        author:'Micah Johnson & Matt Szczur',
        poster:assetUrl('collection/collage/thumbs/GeorgeFloyd.jpg'),
        popupSrc:assetUrl('collection/collage/GeorgeFloyd.jpg'),
        href:'https://opensea.io/assets/0x78c54a7523e7bdd63819a8affba7e8702cd48376/1100020004',
        type:'img',
    },
    {
        title:'Battle of the War Nymphs',
        description:'',
        author:'Grimes x Mac',
        poster:assetUrl('collection/collage/thumbs/BattleOfTheWarNymphs.jpg'),
        popupSrc:assetUrl('collection/collage/BattleOfTheWarNymphs.jpg'),
        href:'https://opensea.io/assets/0x948b3515d81034a3c16d5393c6c155946c93c103/27300020006',
        type:'img',
    },
    {
        title:'Singularity',
        description:'',
        author:'Balkan Karisman',
        poster:assetUrl('collection/collage/thumbs/Singularity.jpg'),
        popupSrc:assetUrl('collection/collage/Singularity.mp4'),
        href:'https://opensea.io/assets/0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0/18041',
        type:'video',
    },
    {
        title:'Demonic Nyan Cat',
        description:'',
        author:'Christ Torres',
        poster:assetUrl('collection/collage/thumbs/demonnyan-still.gif'),
        popupSrc:assetUrl('collection/collage/demonnyan.gif'),
        href:'https://opensea.io/assets/0xb32979486938aa9694bfc898f35dbed459f44424/19',
        type:'img',
    },
    {
        title:'Fancy Nyan Cat',
        description:'',
        author:'Christ Torres',
        poster:assetUrl('collection/collage/thumbs/hatnyan-still.gif'),
        popupSrc:assetUrl('collection/collage/hatnyan.gif'),
        href:'https://opensea.io/assets/0xb32979486938aa9694bfc898f35dbed459f44424/10023',
        type:'img',
    },
    {
        title:'Touch',
        description:'',
        author:'3lau',
        poster:assetUrl('collection/collage/thumbs/Touch.jpg'),
        popupSrc:assetUrl('collection/collage/Touch.mp4'),
        href:'https://opensea.io/assets/0x26b365dd6c6c2c5c1b19658ede5ef00c12402702/38',
        type:'video',
    },
    {
        title:'Caribbean SciFi',
        description:'',
        author:'Rafael Lacoste',
        poster:assetUrl('collection/collage/thumbs/CaribbeanSciFi.jpg'),
        popupSrc:assetUrl('collection/collage/CaribbeanSciFi.jpg'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/5449',
        type:'img',
    },
    {
        title:'Hong Kong 2049',
        description:'',
        author:'TOKYOLUV',
        poster:assetUrl('collection/collage/thumbs/HongKong2049.jpg'),
        popupSrc:assetUrl('collection/collage/HongKong2049.mp4'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/48466',
        type:'video',
    },
    {
        title:'Tokyo Metropolis',
        description:'',
        author:'Benjamin Lee',
        poster:assetUrl('collection/collage/thumbs/TokyoMetropolis.jpg'),
        popupSrc:assetUrl('collection/collage/TokyoMetropolis.mp4'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/22622',
        type:'video',
    },
    {
        title:'Tier 1, #10 - DRIVE',
        description:'',
        author:'Dave Krugman',
        poster:assetUrl('collection/collage/thumbs/Drive.jpg'),
        popupSrc:assetUrl('collection/collage/Drive.jpg'),
        href:'https://opensea.io/assets/0xec71ed650722ef6f98c1c28f0b34c9846c1ba10b/38',
        type:'img',
    },
    {
        title:'Skateboarding: Culture in Motion #7',
        description:'',
        author:'Jake Inez',
        poster:assetUrl('collection/collage/thumbs/Skateboarding.jpeg'),
        popupSrc:assetUrl('collection/collage/Skateboarding.jpeg'),
        href:'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/74180388987835072097633391580607238135275622999050710486878638609709372801025',
        type:'img',
    },
    {
        title:'#40. Chang Mi, Thailand',
        description:'',
        author:'Jacob Briglin',
        poster:assetUrl('collection/collage/thumbs/ChangMiThailand.jpeg'),
        popupSrc:assetUrl('collection/collage/ChangMiThailand.jpeg'),
        href:'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/14416656700475663864726672344569766568452912279528818547653479152721867046913',
        type:'img',
    },
    {
        title:'Bastard Countryside #35',
        description:'',
        author:'Robin Friend',
        poster:assetUrl('collection/collage/thumbs/BastardCountryside.jpg'),
        popupSrc:assetUrl('collection/collage/BastardCountryside.jpg'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/65749',
        type:'img',
    },
    {
        title:'Bastard Countryside #34',
        description:'',
        author:'Robin Friend',
        poster:assetUrl('collection/collage/thumbs/BastardCountryside2.jpg'),
        popupSrc:assetUrl('collection/collage/BastardCountryside2.jpg'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/65747',
        type:'img',
    },
    {
        title:'Memories fade away like cigarettes in the rain',
        description:'',
        author:'Tyler Shields',
        poster:assetUrl('collection/collage/thumbs/MemoriesFadeAway.jpg'),
        popupSrc:assetUrl('collection/collage/MemoriesFadeAway.mp4'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/77670',
        type:'video',
    },
    {
        title:'Payphone',
        description:'',
        author:'Tyler Shields',
        poster:assetUrl('collection/collage/thumbs/Payphone.jpg'),
        popupSrc:assetUrl('collection/collage/Payphone.mp4'),
        href:'https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/52051',
        type:'video',
    },
    {
        title:'American Diners #09',
        description:'',
        author:'Artist',
        poster:assetUrl('collection/collage/thumbs/AmericanDiners9.jpeg'),
        popupSrc:assetUrl('collection/collage/AmericanDiners9.jpeg'),
        href:'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/19584883553916712241852398421302965913957422197351485086550879494722029617153',
        type:'img',
    },
    {
        title:'American Diners #11',
        description:'',
        author:'Artist',
        poster:assetUrl('collection/collage/thumbs/AmericanDiners11.jpeg'),
        popupSrc:assetUrl('collection/collage/AmericanDiners11.jpeg'),
        href:'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/19584883553916712241852398421302965913957422197351485086550879496921052872705',
        type:'img',
    },
    {
        title:'Urban Anomalies #27',
        description:'',
        author:'Artist',
        poster:assetUrl('collection/collage/thumbs/UrbanAnomalies27.jpeg'),
        popupSrc:assetUrl('collection/collage/UrbanAnomalies27.jpeg'),
        href:'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/90759427057310509927547570395708714779512351118091613108582219521065773694977',
        type:'img',
    },
    {
        title:'Form Farm Master Layer',
        description:'',
        author:'untitledxyz',
        poster:assetUrl('collection/collage/thumbs/FormFarmMasterLayer.png'),
        popupSrc:assetUrl('collection/collage/FormFarmMasterLayer.png'),
        href:'https://opensea.io/assets/0xb6dae651468e9593e4581705a09c10a76ac1e0c8/1908',
        type:'img',
    },
    {
        title:'Symbiosis',
        description:'',
        author:'Andreas Wannerstedt',
        poster:assetUrl('collection/collage/thumbs/Symbiosis.jpg'),
        popupSrc:assetUrl('collection/collage/Symbiosis.mp4'),
        href:'https://opensea.io/assets/0x2a46f2ffd99e19a89476e2f62270e0a35bbf0756/39998',
        type:'video',
    },
    {
        title:'Endangered',
        description:'',
        author:'Rarezo',
        poster:assetUrl('collection/collage/thumbs/Endangered.jpg'),
        popupSrc:assetUrl('collection/collage/Endangered.mp4'),
        href:'https://opensea.io/assets/0x2a46f2ffd99e19a89476e2f62270e0a35bbf0756/39191',
        type:'video',
    }   
]